var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendationsIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.365,
    height: 24.496,
    viewBox: "0 0 19.365 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.071,
    y1: 1.031,
    x2: 1.226,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3503",
    "data-name": "Groupe 3503",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2011",
    "data-name": "Trac\\xE9 2011",
    d: "M-289.117,2719.449a1.986,1.986,0,0,0,1.919,2.047,1.986,1.986,0,0,0,1.919-2.047c0-4.344-2.764-8.141-6.572-9.03a8.088,8.088,0,0,0-7.17,1.771,9.217,9.217,0,0,0-3.159,7.024v13.438a1.986,1.986,0,0,0,1.919,2.047,1.986,1.986,0,0,0,1.919-2.047v-13.437a5.034,5.034,0,0,1,1.727-3.835,4.445,4.445,0,0,1,3.945-.961A5.019,5.019,0,0,1-289.117,2719.449Z",
    transform: "translate(302.181 -2710.202)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2012",
    "data-name": "Trac\\xE9 2012",
    d: "M-259.148,2769.578l-6.191-6.022a2.054,2.054,0,0,0-2.905.04,2.054,2.054,0,0,0,.04,2.905l6.191,6.022a2.047,2.047,0,0,0,1.432.582,2.049,2.049,0,0,0,1.473-.622A2.055,2.055,0,0,0-259.148,2769.578Z",
    transform: "translate(277.891 -2748.609)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsIconColor);
export default __webpack_public_path__ + "static/media/recommendationsIconColor.7eff633b355e2c5b7331ec550e84ce6d.svg";
export { ForwardRef as ReactComponent };